@import 'common/component';
@import 'forms/reset/input';

:host {
  display: block;
}

@import 'forms/custom/o2-input-group';
@import 'forms/custom/o2-label';
@import 'forms/custom/o2-input';
